import { message } from 'antd';
import HTTP from '../../../utils/Http';
import {
    AUTH_CHECK,
    AUTH_DISGUISE,
    AUTH_LOGIN,
    AUTH_LOGOUT,
    AUTH_PERMISSIONS,
    AUTH_REFRESH_TOKEN,
    AUTH_UNDISGUISE,
    AUTH_USER,
} from './action-types';

const initialState = {
    isAuthenticated: false,
    permissions: [],
    user: null,
};

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case AUTH_REFRESH_TOKEN:
        case AUTH_LOGIN:
            return login(state, payload);
        case AUTH_CHECK:
            return checkAuth(state);
        case AUTH_LOGOUT:
            return logout(state);
        case AUTH_USER:
            return authUser(state, payload);
        case AUTH_PERMISSIONS:
            return authPermissions(state, payload);
        case AUTH_DISGUISE:
            return disguise(state, payload);
        case AUTH_UNDISGUISE:
            return undisguise(state, payload);
        default:
            return state;
    }
};

function login(state, payload) {
    localStorage.setItem('access_token', payload.accessToken);
    localStorage.setItem('refresh_token', payload.refreshToken);
    localStorage.removeItem('original_tokens');

    HTTP.defaults.headers.common.Authorization = `Bearer ${payload.accessToken}`;

    return {
        ...state,
        isAuthenticated: true,
    };
}

function disguise(state, payload) {
    localStorage.setItem(
        'original_tokens',
        JSON.stringify({
            access: localStorage.getItem('access_token'),
            refresh: localStorage.getItem('refresh_token'),
        })
    );

    localStorage.setItem('access_token', payload.accessToken);
    localStorage.setItem('refresh_token', payload.refreshToken);

    HTTP.defaults.headers.common.Authorization = `Bearer ${payload.accessToken}`;

    message.success('Refresh the page');

    return state;
}

function undisguise(state, payload) {
    const tokens = JSON.parse(localStorage.getItem('original_tokens'));
    localStorage.setItem('access_token', tokens.access);
    localStorage.setItem('refresh_token', tokens.refresh);
    localStorage.removeItem('original_tokens');

    HTTP.defaults.headers.common.Authorization = `Bearer ${tokens.accessToken}`;

    message.success('Refresh the page');

    return state;
}

function authUser(state, payload) {
    return {
        ...state,
        user: payload,
    };
}
function authPermissions(state, payload) {
    return {
        ...state,
        permissions: payload || [],
    };
}

function checkAuth(state) {
    state = Object.assign({}, state, {
        isAuthenticated: !!localStorage.getItem('access_token'),
    });

    if (state.isAuthenticated) {
        HTTP.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
    }

    return state;
}

function logout(state) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('original_tokens');

    HTTP.defaults.headers.common.Authorization = null;
    return {
        ...state,
        isAuthenticated: false,
        user: null,
    };
}

export const getAuth = (state) => state.auth.isAuthenticated;

export default reducer;
